import { lazy } from "react";

import ReasonForVisit from "@/app/components/ReasonForVisit/ReasonForVisit";
import type { StepComponentKey } from "@/types/scheduler-machine";

export const STEP_COMPONENTS: Partial<Record<StepComponentKey, React.ComponentType>> = {
  "reason-for-visit": ReasonForVisit,
  "patient-information": lazy(
    () => import("@/app/components/PatientInformation/PatientInformation"),
  ),
  "date-time-selection": lazy(() => import("@/app/components/DateAndTime/DateAndTime")),
  "guarantor-information": lazy(
    () => import("@/app/components/GuarantorInformation/GuarantorInformation"),
  ),
  "appointment-review": lazy(
    () => import("@/app/components/ReviewAndConfirmAppt/ReviewAndConfirmAppt"),
  ),
  confirmation: lazy(() => import("@/app/components/Confirmation/Confirmation")),
};
